export function initGtmBootstrap() {
  // Avoid loading GTM in local dev / previews unless explicitly intended.
  if (window.location.hostname !== 'app.getweave.com') {
    console.log('Skipping GTM bootstrap because the app is not running in production.');
    return;
  }

  (function (w: Record<string, any>, d: Document, s: string, l: string, i: string) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement('script');
    const dl = l !== 'dataLayer' ? '&l=' + l : '';

    j.async = true;
    j.src = 'https://tagging.getweave.com/gtm.js?id=' + i + dl;
    f.parentNode?.insertBefore(j, f);
  })(window as unknown as Record<string, any>, document, 'script', 'dataLayer', 'GTM-P8LQGKHP');
}
